import React from 'react';
import ReactTable from "react-table";
import { TableConfig } from '../../../utils/appConfig';
import Pagination from '../../page/Pagination';
import NoData from '../../page/NoData';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const log = new Logger('BULK_OPERATION_STATUS_DETAILS', LOG_LEVELS.DEBUG);

const NoDataComponent = props => (
    <NoData
        noDataText="No Failed Entities"
        {...props}
    />
);

const OPERATION_TYPE_DISPLAY = {
    'BulkDeleteFiles': 'Delete',
    'BulkRedeliverFiles': 'Redeliver'
};

const BulkOperationStatusDetails = ({ operations }) => {
    log.debug('Rendering BulkOperationStatusDetails', operations);

    const failedEntitiesData = operations.flatMap(operation =>
        operation.entities
            .filter(entity => entity.status === "Failed")
            .map(entity => ({
                entityId: entity.entityId,
                fileName: entity.metadata?.fileName || 'N/A',
                error: entity.reason || 'Unknown error',
                operation: OPERATION_TYPE_DISPLAY[operation.operationType] || operation.operationType
            }))
    );

    if (failedEntitiesData.length === 0) {
        return (
            <div className='m4'>
                <LanguageStringResolver string='processedDocumentsPage_NoFailedOperation' />
            </div>
        );
    }

    const columns = [
        {
            Header: 'Entity ID',
            accessor: 'entityId',
            minWidth: 200
        },
        {
            Header: 'File Name',
            accessor: 'fileName',
            minWidth: 300
        },
        {
            Header: 'Operation',
            accessor: 'operation',
            minWidth: 200
        },
        {
            Header: 'Reason',
            accessor: 'error',
            minWidth: 400
        }
    ];

    return (
        <div className="failed-entities-table mt10">
            <ReactTable
                data={failedEntitiesData}
                columns={columns}
                defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE}
                minRows={Math.min(failedEntitiesData.length, TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE)}
                showPagination={failedEntitiesData.length > TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE}
                PaginationComponent={Pagination}
                showPageJump={true}
                pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                noDataText=""
                NoDataComponent={NoDataComponent}
                className="-striped -highlight"
            />
        </div>
    );
};


export default BulkOperationStatusDetails;
